import Parser from "html-react-parser";

type FooterProps = {
  dataHtml: string;
  cssReady: boolean;
};

function Footer({ dataHtml, cssReady }: FooterProps) {
  // Hold off on painting the real markup until css is bound to the html content
  if (!cssReady || !dataHtml) {
    return <div></div>;
  }

  try {
    return <>{Parser(dataHtml || "")}</>;
  } catch (error) {
    console.error("Footer render error:", error);
    return <></>;
  }
}
export default Footer;
